var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnBoarding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 832,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1280v832H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6E4E7",
    d: "M529.189 251.264h2.64v35.904h21.032v2.376h-23.672v-38.28Zm33.836-.572v39.644h-2.596v-20.768h-12.892v-2.376h12.892v-16.5h2.596Zm40.544 0h2.596v39.644h-2.596v-39.644Zm-2.024 37.224c-2.258.264-4.693.484-7.304.66-2.61.205-5.265.367-7.964.484-2.669.147-5.309.249-7.92.308-2.61.088-5.045.147-7.304.176l-.352-2.288c2.318-.029 4.782-.088 7.392-.176 2.611-.059 5.236-.147 7.876-.264 2.64-.117 5.251-.264 7.832-.44 2.611-.176 5.075-.396 7.392-.66l.352 2.2Zm-5.676-21.296c0 3.725-.938 6.468-2.816 8.228-1.877 1.731-4.634 2.596-8.272 2.596-3.666 0-6.438-.865-8.316-2.596-1.877-1.731-2.816-4.459-2.816-8.184v-5.06c0-3.725.939-6.453 2.816-8.184 1.878-1.731 4.65-2.596 8.316-2.596 3.638 0 6.395.88 8.272 2.64 1.878 1.731 2.816 4.459 2.816 8.184v4.972Zm-19.58 0c0 1.76.235 3.197.704 4.312.47 1.115 1.1 1.995 1.892 2.64a6.894 6.894 0 0 0 2.684 1.276c1.027.205 2.098.308 3.212.308 1.086 0 2.127-.103 3.124-.308a6.881 6.881 0 0 0 2.728-1.276c.792-.645 1.423-1.525 1.892-2.64.47-1.115.704-2.552.704-4.312v-4.928c0-1.76-.234-3.197-.704-4.312-.469-1.115-1.1-1.98-1.892-2.596a6.163 6.163 0 0 0-2.728-1.276 13.573 13.573 0 0 0-3.124-.352 14.36 14.36 0 0 0-3.212.352 6.156 6.156 0 0 0-2.684 1.276c-.792.616-1.422 1.481-1.892 2.596-.469 1.115-.704 2.552-.704 4.312v4.928Zm84.536-15.928h2.596v39.776h-2.596v-20.9h-6.908v20.196h-2.596v-38.72h2.596v16.192h6.908v-16.544Zm-29.392 2.948v33.528h16.544v2.376h-19.184v-38.28h17.908v2.376h-15.268Zm44.329 20.548v5.588h24.2v-5.588h2.596v16.148h-29.436v-16.148h2.64Zm0 13.904h24.2v-6.072h-24.2v6.072Zm-1.76-34.452v13.728h20.108v2.376h-22.748v-18.48h21.428v2.376h-18.788Zm35.42 7.568h-6.864v10.076h-2.596v-20.592h2.596v8.184h6.864v2.332Zm36.761-10.516h2.596v39.644h-2.596v-39.644Zm-10.78 27.808c0 3.843-.792 6.717-2.376 8.624-1.584 1.907-4.195 2.86-7.832 2.86-3.638 0-6.263-.953-7.876-2.86-1.584-1.907-2.376-4.767-2.376-8.58v-16.28c0-3.813.792-6.673 2.376-8.58 1.613-1.907 4.238-2.86 7.876-2.86 3.637 0 6.248.968 7.832 2.904 1.584 1.907 2.376 4.767 2.376 8.58V278.5Zm-17.82.66c0 1.555.19 2.875.572 3.96.381 1.085.909 1.965 1.584 2.64a6.205 6.205 0 0 0 2.42 1.452c.938.323 1.95.484 3.036.484 1.085 0 2.082-.161 2.992-.484a5.822 5.822 0 0 0 2.42-1.452c.674-.675 1.202-1.555 1.584-2.64.381-1.085.572-2.405.572-3.96v-17.468c0-1.555-.191-2.875-.572-3.96-.382-1.085-.91-1.965-1.584-2.64a5.822 5.822 0 0 0-2.42-1.452c-.91-.323-1.907-.484-2.992-.484a9.264 9.264 0 0 0-3.036.484 6.205 6.205 0 0 0-2.42 1.452c-.675.675-1.203 1.555-1.584 2.64-.382 1.085-.572 2.405-.572 3.96v17.468Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 544,
    r: 48.5,
    stroke: "#C6E4E7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 333,
    r: 63.5,
    stroke: "#C6E4E7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1107,
    cy: 407,
    r: 33.5,
    stroke: "#C6E4E7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 997,
    cy: 866,
    r: 115,
    fill: "#FFEBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 831,
    r: 100,
    fill: "#FFEBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752,
    cy: 892,
    r: 100,
    fill: "#FFEBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 865,
    r: 100,
    fill: "#FFEBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 792,
    r: 140,
    fill: "#FFEBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 957,
    cy: 751,
    r: 90,
    fill: "#FFEBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1251,
    cy: 852,
    r: 80,
    fill: "#FFEBF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 716,
    r: 125,
    fill: "#D0D6E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 771,
    r: 100,
    fill: "#D0D6E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397,
    cy: 673,
    r: 100,
    fill: "#D0D6E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 809,
    r: 100,
    fill: "#D0D6E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.5,
    cy: 843.5,
    fill: "#D0D6E3",
    rx: 116.5,
    ry: 108.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 697,
    r: 175,
    fill: "#D0D6E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 23,
    r: 100,
    fill: "#C6E4E7",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 180,
    r: 50,
    fill: "#C6E4E7",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 23,
    r: 125,
    fill: "#D0D6E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    r: 100,
    fill: "#D0D6E3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0D9DC",
    d: "M453.165 462.632c0-7.597 3.7-13.517 11.1-17.76 7.498-4.341 17.809-6.759 30.932-7.252V420.6h-52.688c-2.862 0-4.292-1.283-4.292-3.848 0-2.664 1.43-3.996 4.292-3.996h113.96c2.861 0 4.292 1.332 4.292 3.996 0 2.565-1.431 3.848-4.292 3.848h-52.392v17.02c6.512.197 12.382.937 17.612 2.22 5.229 1.184 9.669 2.861 13.32 5.032 3.65 2.072 6.462 4.588 8.436 7.548 1.973 2.96 2.96 6.364 2.96 10.212 0 4.045-1.086 7.597-3.256 10.656-2.171 3.157-5.279 5.821-9.324 7.992-3.947 2.171-8.831 3.799-14.652 4.884-5.723 1.085-12.186 1.628-19.388 1.628-7.203 0-13.715-.543-19.536-1.628-5.723-1.085-10.607-2.713-14.652-4.884-3.947-2.171-7.006-4.835-9.176-7.992-2.171-3.059-3.256-6.611-3.256-10.656Zm84.508 0c0-2.96-.938-5.525-2.812-7.696-1.875-2.269-4.49-4.095-7.844-5.476-3.355-1.48-7.351-2.565-11.988-3.256-4.638-.691-9.719-1.036-15.244-1.036-5.526 0-10.607.345-15.244 1.036-4.638.691-8.634 1.776-11.988 3.256-3.355 1.381-5.97 3.207-7.844 5.476-1.875 2.171-2.812 4.736-2.812 7.696s.937 5.525 2.812 7.696c1.874 2.269 4.489 4.095 7.844 5.476 3.354 1.48 7.35 2.565 11.988 3.256 4.637.691 9.718 1.036 15.244 1.036 5.525 0 10.606-.345 15.244-1.036 4.637-.691 8.633-1.776 11.988-3.256 3.354-1.381 5.969-3.207 7.844-5.476 1.874-2.171 2.812-4.736 2.812-7.696Zm-3.108-93.536c.098-1.776-.198-2.861-.888-3.256-.592-.395-1.431-.592-2.516-.592h-73.556c-2.566 0-3.848-1.283-3.848-3.848 0-.987.296-1.875.888-2.664.69-.789 1.677-1.184 2.96-1.184h75.628c3.749 0 6.462.691 8.14 2.072 1.677 1.381 2.417 3.601 2.22 6.66-.198 5.229-.691 10.903-1.48 17.02a176.24 176.24 0 0 1-3.256 17.76 21.13 21.13 0 0 1-.444 1.48c-.198.592-.543 1.184-1.036 1.776-.395.493-.938.937-1.628 1.332-.691.296-1.628.296-2.812 0-.987-.197-1.727-.592-2.22-1.184a7.446 7.446 0 0 1-.888-1.776 6.26 6.26 0 0 1 0-1.924c.098-.691.197-1.233.296-1.628a150.838 150.838 0 0 0 2.96-15.392c.789-5.032 1.282-9.916 1.48-14.652Zm47.127 98.716c-2.861 0-4.292-1.283-4.292-3.848 0-2.664 1.431-3.996 4.292-3.996h113.96c2.862 0 4.292 1.332 4.292 3.996 0 2.565-1.43 3.848-4.292 3.848h-113.96Zm101.084-92.648c0 5.723-.246 11.692-.74 17.908a276.34 276.34 0 0 1-1.776 18.204 269.63 269.63 0 0 1-2.516 17.02c-.888 5.328-1.825 10.015-2.812 14.06l-.444 1.332a5.223 5.223 0 0 1-.888 1.628c-.394.493-.937.888-1.628 1.184-.69.197-1.578.197-2.664 0-1.085-.197-1.874-.543-2.368-1.036a7.521 7.521 0 0 1-.888-1.776 13.767 13.767 0 0 1-.148-1.924c.099-.592.198-1.036.296-1.332.987-3.848 1.924-8.387 2.812-13.616a356.822 356.822 0 0 0 2.368-16.28 340.488 340.488 0 0 0 1.628-17.02c.494-5.723.74-10.903.74-15.54v-2.664c0-1.677-.296-2.664-.888-2.96-.592-.395-1.43-.592-2.516-.592h-73.556c-2.565 0-3.848-1.283-3.848-3.848 0-.987.296-1.875.888-2.664.691-.789 1.678-1.184 2.96-1.184h75.628c3.75 0 6.414.691 7.992 2.072 1.579 1.381 2.368 3.601 2.368 6.66v2.368Zm91.38 65.86c0 4.144-1.086 7.351-3.256 9.62-2.072 2.269-5.476 3.404-10.212 3.404h-24.42c-4.736 0-8.19-1.135-10.36-3.404-2.072-2.269-3.108-5.476-3.108-9.62v-61.272c0-4.144 1.036-7.351 3.108-9.62 2.17-2.269 5.624-3.404 10.36-3.404h24.42c4.736 0 8.14 1.135 10.212 3.404 2.17 2.269 3.256 5.476 3.256 9.62v61.272Zm-42.624-.444c0 2.072.394 3.552 1.184 4.44.789.888 2.17 1.332 4.144 1.332h23.384c1.973 0 3.354-.444 4.144-1.332.789-.888 1.184-2.368 1.184-4.44v-60.532c0-2.072-.395-3.552-1.184-4.44-.79-.888-2.171-1.332-4.144-1.332H736.86c-1.974 0-3.355.444-4.144 1.332-.79.888-1.184 2.368-1.184 4.44v60.532Zm99.012 41.736c0 1.381-.444 2.467-1.332 3.256-.79.789-1.776 1.184-2.96 1.184-1.283 0-2.368-.395-3.256-1.184-.79-.789-1.184-1.875-1.184-3.256v-68.82h-18.796v62.012c0 1.381-.444 2.467-1.332 3.256-.79.789-1.776 1.184-2.96 1.184-1.283 0-2.368-.395-3.256-1.184-.79-.789-1.184-1.875-1.184-3.256V360.364c0-1.381.394-2.467 1.184-3.256.888-.789 1.973-1.184 3.256-1.184 1.184 0 2.17.395 2.96 1.184.888.789 1.332 1.875 1.332 3.256v45.288h18.796v-48.248c0-1.381.394-2.467 1.184-3.256.888-.789 1.973-1.184 3.256-1.184 1.184 0 2.17.395 2.96 1.184.888.789 1.332 1.875 1.332 3.256v124.912Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1280v832H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoarding);
export default __webpack_public_path__ + "static/media/onBoarding.341e197119d1ceec8c2d71f833f2a932.svg";
export { ForwardRef as ReactComponent };